import { render, staticRenderFns } from "./todo-detail.vue?vue&type=template&id=e3175b56"
import script from "./todo-detail.vue?vue&type=script&lang=js"
export * from "./todo-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports